import { Component, Injector, OnInit } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { CustomerBillingResellerListData } from '../customer-billing-reseller-list-data';
import { CustomerService } from '../../customer-billing-customer/customer.service';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { fiCustomerType } from '../../customer-billing-customer/customer-type';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';

@Component({
    selector: 'fi-customer-billing-reseller-list',
    template: '<fi-items-list [settings]="ListData"></fi-items-list>',
    styleUrls: ['./customer-billing-reseller-list.component.scss'],
    standalone: false,
})
export class CustomerBillingResellerListComponent
    extends ItemsListContainerBase<CustomerBillingResellerListData>
    implements OnInit
{
    constructor(
        private customerService: CustomerService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new CustomerBillingResellerListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        return this.customerService.GetOtherBillingCustomers(this.getSearchParameterModel()).then((response) => {
            this.ListData.appendData(response);
        });
    }

    protected SetItemsCount(): IFiHttpPromise<number> {
        return this.customerService.GetOtherBillingCustomersCount(fiCustomerType.Reseller);
    }

    private getSearchParameterModel() {
        const result = {
            CustomerType: fiCustomerType.Reseller,
            Names: [],
            SelectedSort: {
                ColumnName: this.ListData.Sort.Column,
                SortDirection: this.ListData.Sort.Reverse,
            },
        };

        Object.assign(result, this.ListData.getOffsetParams());

        return result;
    }
}
